import {
  BUTTON_ACTIONS,
  MODAL_CONFIGURATION_TYPE,
  NG_SELECT_QUERIES,
} from '../../helpers/ui/ui.constant';
import { Affiliate } from '../api/affiliate.interface';
import { RestrictionSetting } from '../api/restriction-settings.interface';
import { ModalWithAction } from './bootstrap-modal.interface';
import { TranslationsPerLanguage } from './language.interface';

// TODO: do not add more fields, extend the interface please
export interface NgSelect<T> {
  value: T;
  label: string;
  icon?: string;
  group?: string;
  currencyId?: string;
  userType?: string;
}

export type ButtonAction = (typeof BUTTON_ACTIONS)[keyof typeof BUTTON_ACTIONS];
export type PageConfigurationType =
  (typeof MODAL_CONFIGURATION_TYPE)[keyof typeof MODAL_CONFIGURATION_TYPE];

export type NgSelectQuery =
  (typeof NG_SELECT_QUERIES)[keyof typeof NG_SELECT_QUERIES];

export interface CustomDateSelector {
  selectedYears?: number[];
  selectMonth?: string[];
  selectedDays?: number[];
  selectWeekDay?: string[];
}

export interface CheckedEventTarget extends Event {
  target: HTMLInputElement;
}

export interface ModalData {
  name: string;
  title: string;
  dataValue: string[];
  [key: string]: any;
}

export interface Select {
  label: string;
  value: string;
}

// TODO: move to a better place (ui constant)
export const TYPE_DATE = {
  DAY: 'day',
  MONTH: 'month',
  YEAR: 'year',
};

export interface RestrictionSettingModal
  extends ModalWithAction<RestrictionSetting> {
  idEntity?: string;
}

export interface CardSocialMedia {
  title: string;
  countClicks: number;
  color?: string;
  icon?: string;
  growth?: string;
  series?: number[];
}

export interface CardStatistics {
  title: string;
  colorClass: string;
  icon: string;
  value: number | null | string;
}

export interface Statistics {
  affiliate: Affiliate[];
  totalCounterClicksResult: [];
  totalPlayersForUser: number;
}

export interface ClickData {
  total: number;
  date: string;
}
export interface GenderData {
  total: number;
  gender: string;
  date: string;
}

export interface CitiesData {
  city: number;
  total: number;
}

export interface BadgeStyleConfig extends TranslationsPerLanguage {
  color: string;
  icon?: string;
}

export interface TranslatedSelectOption<T> {
  label: TranslationsPerLanguage;
  value: T;
}

export interface Breadcrumb {
  title: string;
  items: string[];
  active_item: string;
}

export type Theme = 'light-only' | 'dark-only';
export type ThemeKeys = 'LIGHT_ONLY' | 'DARK_ONLY';
export interface ThemeState {
  value: Theme;
}
export interface CountryPhoneCodeOption extends NgSelect<string> {
  telephoneCode: string;
  icon: string; // este campo lo usaremos como code (ej. ECU, CU)
}
